// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgRestoreSize14 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 14 14"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.66699 1.58337V0.333374H12.0003C12.9208 0.333374 13.667 1.07957 13.667 2.00004V12C13.667 12.9205 12.9208 13.6667 12.0003 13.6667H2.00033C1.07985 13.6667 0.333659 12.9205 0.333659 12V8.66671H1.58366V12C1.58366 12.2302 1.77021 12.4167 2.00033 12.4167H12.0003C12.2304 12.4167 12.417 12.2302 12.417 12V2.00004C12.417 1.76992 12.2304 1.58337 12.0003 1.58337H8.66699ZM8.45866 6.79175C8.45866 7.71222 7.71247 8.45841 6.79199 8.45841L3.45866 8.45841L3.45866 7.20841L6.32366 7.20841L1.35005 2.23369C1.10597 1.98961 1.10597 1.59388 1.35005 1.34981C1.59413 1.10573 1.98986 1.10573 2.23393 1.34981L7.20866 6.32508L7.20866 3.45841H8.45866L8.45866 6.79175Z"
				/>
			</Svg>
		);
	}
);
SvgRestoreSize14.defaultProps = {
	size: 14,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgRestoreSize14;
